import { useMemo, useState } from 'react';
import { SearchSectionForm } from 'src/components/common/form/search/SearchSectionForm';
import { SearchCodeModalForm } from 'src/components/common/form/search/SearchCodeModalForm';
import { SearchDropDownForm } from 'src/components/common/form/search/SearchDropDownForm';
import { SearchYearSingleForm } from 'src/components/common/form/search/SearchYearSingleForm';
import useUiuxStore from 'src/store/useUiuxStore';
import { useCommonCodeStore } from 'src/store/useCommonCodeStore';
import { useInfoFormEvents } from 'src/hooks/useInfoFormEvents';
import { InfoCodeSearchFieldConfig } from 'src/types/info-form';
import { useEQM3010_R01Store, defaultEQM3010_R01Filter } from './Store_EQM3010_R01';

const parseYearToDate = (year: number): Date | undefined => {
	if (!Number.isFinite(year) || year < 1000 || year > 9999) return undefined;
	return new Date(year, 0, 1);
};

interface Props {
	onCopyPreviousYear: () => void;
}

export const SearchSection_EQM3010_R01 = ({ onCopyPreviousYear }: Props) => {
	const { EQM3010_R01Filter, setEQM3010_R01Filter } = useEQM3010_R01Store();
	const { setCodeSearchModalProps } = useUiuxStore();
	const { compCdList } = useCommonCodeStore();
	const [pickerVisible, setPickerVisible] = useState(false);
	const [pickerPosition, setPickerPosition] = useState({ top: 0, left: 0 });

	const yearValue = useMemo(
		() => parseYearToDate(EQM3010_R01Filter.year),
		[EQM3010_R01Filter.year],
	);

	const eqmFocusId = 'equipmentCd_search';

	const infoFieldConfigs: InfoCodeSearchFieldConfig[] = [
		{
			fieldName: 'equipmentCd',
			category: '계측기',
			focusId: eqmFocusId,
			responseMapping: { equipmentCd: 'equipmentCd', equipmentNm: 'equipmentNm' },
			extraFilter: () => ({ equipmentType: 'TESTER' }),
		},
	];

	const { getFieldHandlers } = useInfoFormEvents({
		editData: EQM3010_R01Filter,
		setEditData: setEQM3010_R01Filter,
		defaultData: defaultEQM3010_R01Filter,
		infoFieldConfigs,
		setCodeSearchModalProps,
		formName: 'EQM3010_R01_search',
	});

	return (
		<SearchSectionForm>
			<SearchDropDownForm
				label="사업장"
				value={EQM3010_R01Filter.compCd}
				optionList={compCdList}
				onChangeItem={(selectedItem) => setEQM3010_R01Filter({ compCd: selectedItem?.compCd || '' })}
			/>

			<SearchYearSingleForm
				label="연도"
				visible={pickerVisible}
				setVisible={setPickerVisible}
				value={yearValue}
				onChange={(d) => { if (d) setEQM3010_R01Filter({ year: d.getFullYear() }); }}
				pickerPosition={pickerPosition}
				setPickerPosition={setPickerPosition}
			/>

			<SearchCodeModalForm
				label="계측기"
				value={EQM3010_R01Filter.equipmentCd}
				valueLabel={EQM3010_R01Filter.equipmentNm}
				handleFoucsId={eqmFocusId}
				onChange={getFieldHandlers('equipmentCd').onChange}
				onDoubleClick={getFieldHandlers('equipmentCd').onDoubleClick}
				onKeyDown={getFieldHandlers('equipmentCd').onEnterKeyDown}
			/>
			<button
				type="button"
				onClick={onCopyPreviousYear}
				className="flex-shrink-0 bg-white hover:bg-gray-100 ml-20  border border-gray-300 text-gray-800 font-semibold px-4 rounded shadow h-[30px]"
			>
				전년계획복사
			</button>
		</SearchSectionForm>
	);
};
